import useSubscriptionSuspense from '../utils/useSubscriptionSuspense';
import createListenHook from '../createListenHook';

export default createListenHook(useSubscriptionSuspense);
